import {AxiosError} from "axios";
import Vue from 'vue';

export class ModelErrors {
    errors: any = {};

    constructor(errors?: any) {
        this.setErrors(errors);
    }

    setErrors(errors?: Record<string, string>): any {
        this.errors = errors ? ({ ...errors }) : {};
        return this;
    }

    hasErrorsSplit(attribute: string, split = '|'): boolean {
        const attributes = attribute.split(split);
        for (const attr of attributes) if (this.has(attr)) return true;
        return false;
    }

    getErrorSplit(attribute: string, split = '|'): boolean | string {
        const attributes = attribute.split(split);
        let message;
        for (const attr of attributes) {
            message = this.get(attr);
            if (message) return message;
        }
        return false;
    }

    has(attribute?: string): boolean {
        return Boolean((attribute && (attribute in this.errors) && this.errors[attribute])
            || (!attribute && (Object.keys(this.errors).length > 0)));
    }

    getMessage(attribute: string): string {
        if (!this.has(attribute)) return '';
        const res = this.errors[attribute];
        return Array.isArray(res) ? res[0] : res;
    }

    get(attribute: string): string {
        return this.getMessage(attribute);
    }

    set(attribute: string, error: string): void {
        // this.errors = { ...this.errors, [attribute]: error };
        Vue.set(this.errors, attribute, error);
    }

    clear(attribute?: string): void {
        if (!attribute) this.setErrors();
        else this.errors = {};
    }

    getFirstErrorAttribute(): string {
        const keys = Object.keys(this.errors);
        return keys.length == 0 ? '' : keys[0];
    }

    getFirstError(): string {
        if (!this.has()) return '';
        return this.errors[this.getFirstErrorAttribute()];
    }
}

export interface WebFormModelInterface {
    errors: ModelErrors;
    hints: any;
    labels: any;
    values: any;
    options: any;
    required: any;

    getLabel(attribute: string): string;
}

// @deprecated
export enum ModelEvents {
    modelLoadingStart = 'model-loading-start',
    modelLoaded = 'model-loaded',
    modelLoadingFail = 'model-loading-fail',
    sourceAccountUpdate = 'source-account-update',
    documentCreated = 'document-created',
    documentVerified = 'document-verified',
    modelSubmitStart = 'model-submit-start',
    modelInvalidated = 'model-invalidated'
}

export interface WebFormModelOptions extends Record<string, any> {

}


export class BasicFormModel {

}


export class WebFormModel extends BasicFormModel implements WebFormModelInterface {
    errors: ModelErrors = new ModelErrors();

    hints: any = {};

    labels: any = {};

    values: Record<string, any> | any = {};

    protected defaultValues: any = {};

    options: WebFormModelOptions = {};

    required: any = [];

    constructor(model?: any) {
        super();
        if (model) this._setData(model);
    }

    public _setData(model: any): void {
        this.errors.setErrors(model.errors);
        this.hints = {...this.hints, ...model.hints};
        this.labels = {...this.labels, ...model.labels};
        this.values = {...this.values, ...model.values};
        this.defaultValues = {...this.defaultValues, ...model.values};
        this.required = model.required.slice();
        this.options = {...this.options, ...model.options};
    }

    resetValues(): void {
        this.values = Object.assign(this.values, this.defaultValues);
    }

    setValues(values: any): void {
        this.values = Object.assign({}, this.values, values);
    }

    hasErrors(attribute?: string): boolean {
        return this.errors.has(attribute);
    }

    getError(attribute: string): string {
        return this.errors.has(attribute) ? this.errors.getMessage(attribute) : '';
    }

    getHint(attribute: string): string {
        return (attribute in this.hints) ? this.hints[attribute] : '';
    }

    getLabel(attribute: string): string {
        return (attribute in this.labels) ? this.labels[attribute] : attribute;
    }

    getValue(attribute: string): any {
        return (attribute in this.values) ? this.values[attribute] : null;
    }

    setValue(attribute: string, value: any): any {
        // this.values = { ...this.values, [attribute]: value };
        Vue.set(this.values, attribute, value);
    }

    isRequiredAttribute(attribute: string): boolean {
        return this.required.indexOf(attribute) > -1;
    }

    checkAxiosError(axiosError: AxiosError, modelName = 'model') {
        WebFormModel.parseAxiosError(axiosError, this.errors, modelName);
    }

    getValuesHash(): string {
        try {
            return JSON.stringify(this.values);
        } catch (e) {
            return '';
        }
    }

    static parseAxiosError(axiosError: AxiosError, errors: ModelErrors, modelName = 'model') {
        if (axiosError && (typeof axiosError === 'object')
            && axiosError.response
            && axiosError.response.status) {
            if (axiosError.response.status == 422) {
                errors.setErrors((axiosError.response.data as any)[modelName]?.errors);
            } else {
                let requestMsg = '';
                if (axiosError.request as XMLHttpRequest) {
                    requestMsg = axiosError.request.responseUrl ? ` Request Url ${axiosError.request.responseUrl}.` : '';
                }
                errors.set('http', `Response Status ${axiosError.response.status}.${requestMsg}`);
            }
        }
    }

    /**
     * @deprecated
     * @param axiosError
     */
    static parseAxiosWebapiModelErrors(axiosError): ModelErrors {
        const result = new ModelErrors();
        if (axiosError && (typeof axiosError === 'object')
            && axiosError.response
            && axiosError.response.status) {
            if (axiosError.response.status == 422) {
                result.setErrors(axiosError.response.data.model.errors);
            } else {
                result.set('http', `Response Status ${axiosError.response.status}`);
            }
        }
        return result;
    }

}